import React from "react";
import "../WhyChooseUs/WhyChooseUs.css";
import { motion } from "framer-motion";

import image1 from "../Assets/home-thumb-1.png";
import image2 from "../Assets/home-thumb-2.png";
import image3 from "../Assets/home-thumb-3.png";

function WhyChooseUs() {
  return (
    <>
      <div className="why-choose-us">
        <div className="why-choose-us-container">
          <motion.div
            initial={{ opacity: 0 }}
            transition={{ duration: 0.9 }}
            whileInView={{ opacity: 1 }}
          >
            <div className="why-choose-us-card">
              <div>
                <p className="why-choose-us-card-text">
                  "Inhaled steroids are recommended for both adults and children with persistent asthma."
                </p>
              </div>
              <div>
                <img
                  src={image2}
                  alt="Inhaled Steroids"
                  className="why-choose-us-card-avatar"
                />
              </div>
              <div>
                <p className="why-choose-us-card-text">
                  "According to WHO update, the annual worldwide deaths from asthma have been estimated at 250,000."
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            transition={{ duration: 0.9 }}
            whileInView={{ opacity: 1 }}
          >
            <div className="why-choose-us-card">
              <div>
                <p className="why-choose-us-card-text">
                  "Asthma in seniors can be harder to diagnose and treat, according to the National Heart, Lung and Blood Institute."
                </p>
              </div>
              <div>
                <img
                  src={image1}
                  alt="Asthma Treatment"
                  className="why-choose-us-card-avatar"
                />
              </div>
              <div>
                <p className="why-choose-us-card-text">
                  "MDI dose in inhaled medicines is up to 40 times less than that of tablets."
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            transition={{ duration: 0.9 }}
            whileInView={{ opacity: 1 }}
          >
            <div className="why-choose-us-card">
              <div>
                <p className="why-choose-us-card-text">
                  "Today's inhalers are so safe, even mothers who breastfeed can take inhalers without any harm to the child."
                </p>
              </div>
              <div>
                <img
                  src={image3}
                  alt="Safe Inhalers"
                  className="why-choose-us-card-avatar"
                />
              </div>
              <div>
                <p className="why-choose-us-card-text">
                  "Rescue inhalers can reduce the number of asthma-related deaths."
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        <div className="approved-whychooseus">
          <span>
            "State of the art WHO-GMP, ISO 9001:2008, and NPCB, PIC/S Malaysia approved manufacturing facility."
          </span>
        </div>
      </div>
    </>
  );
}

export default WhyChooseUs;
